import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * Contact service class containing all methods to retrieve contacts
 */
class ContactService {
  static getContacts(limit = 10, page = 1) {
    return ApiHelper.fetch(`${API.URL + API.CONTACTS}?pageSize=${limit}&page=${page}`)
  }

  static getContactsByCompany(companyId) {
    return ApiHelper.fetch(`${API.URL + API.CONTACTS}/byCompany/${companyId}`)
  }

  static getContact(id) {
    return ApiHelper.fetch(`${API.URL + API.CONTACTS}/${id}`)
  }

  static updateContact(contact) {
    if (typeof contact._id === 'undefined') {
      return this.addContact(contact)
    }

    return ApiHelper.fetch(`${API.URL + API.CONTACTS}/${contact['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        contact
      })
    })
  }

  static addContact(contact) {
    return ApiHelper.fetch(`${API.URL + API.CONTACTS}`, {
      method: 'POST',
      body: JSON.stringify({
        contact
      })
    })
  }

  static deleteContact(id) {
    return ApiHelper.fetch(`${API.URL + API.CONTACTS}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default ContactService
